import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

export const AllProductContainer = styled.div`
  display: grid;
  row-gap: 40px;
  column-gap: 10px;
  margin-top: 16px;
  grid-template-columns: repeat(2, 1fr);
`;

export const ShowMoreButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid ${colors.gray200};
  background: ${colors.white};
`;

export const SkeletonSection = styled.div`
  padding: 22px 12px;
  overflow: hidden;

  .title {
    margin-bottom: 22px;
  }
`;

export const SkeletonProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr) 0.5fr;
  gap: 10px;
`;

export const SkeletonProduct = styled.div`
  .image {
    margin-bottom: 12px;
  }

  .title {
    margin-bottom: 6px;
  }

  .info {
    margin-bottom: 3px;
  }
`;

export const SkeletonAllProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 16px;
`;

export const SkeletonAllProduct = styled.div`
  .image {
    margin-bottom: 12px;
  }

  .title,
  .info {
    margin-bottom: 6px;
  }
`;
